import { createAction, props } from '@ngrx/store';
import { IEmployeeParams, ICurrentSelfieResponse, IPreviousSelfieResponse } from '../models/selfie.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

//CURRENT SELFIES
export const loadCurrentSelfieRequest = createAction('[Selfie] Load Current Selfie Request', props<{ request: string }>());

export const loadCurrentSelfieResponse = createAction(
  '[Selfie] Load Current Selfies Success',
  props<{ response: ICurrentSelfieResponse }>()
);

export const loadCurrentSelfieFailure = createAction(
  '[Selfie] Load Current Selfie Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

//PREVIOUS SELFIES
export const loadPreviousSelfieRequest = createAction('[Selfie] Load Previous Selfie Request', props<{ request: string }>());

export const loadPreviousSelfieResponse = createAction(
  '[Selfie] Load Previous Selfies Success',
  props<{ response: IPreviousSelfieResponse[] }>()
);

export const loadPreviousSelfieFailure = createAction(
  '[Selfie] Load Previous Selfie Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
